import type { QueryFunctionContext } from '@tanstack/react-query';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { asrProxyKeys } from 'app/queries/asrProxy/asrProxyKeys';
import type { TCall } from 'app/queries/types/TCall';
import { AsrProxyService } from './AsrProxyService';

export const ASR_JOBS_FETCH_LIMIT = 300;

type TParams = QueryFunctionContext<ReturnType<typeof asrProxyKeys.jobs>>;

export const createFetchAsrJobsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ search }], signal }: TParams) =>
    call(() => cancelOnSignal(AsrProxyService.jobs(ASR_JOBS_FETCH_LIMIT, search.trim() || undefined), signal), {
      dontRedirectOnError: true,
    });
